import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import DatePicker from 'react-datepicker';
import ReactTable from 'react-table';
import { getPayrollList, generatePayroll } from '../../../actions/payroll';
import { PAYROLL_RUNS_LIST_PAGE_SIZE } from '../../../constants/general';
import { getColumnWidth } from '../../../helpers/general';
import TableBaseComponent from '../../common/TableBaseComponent';
import { monthDayYearFormat, uiDateFormatShort } from '../../../constants/date';
import { UIShowAlert } from '../../../actions/ui';

class Payroll extends TableBaseComponent {
  static propTypes = {
    initialData: PropTypes.array.isRequired,
    pagesQuantity: PropTypes.number.isRequired,
    getPayrollList: PropTypes.func.isRequired,
    generatePayroll: PropTypes.func.isRequired
  };
  state = {
    activePage: this.getActivePage(),
    loading: true,
    filteringFieldsList: [],
    data: [],
    columns: [],
    selectedDate: null
  };

  componentDidMount () {
    this.loadPayrollList(this.state.activePage);
  }

  loadPayrollList = activePage => {
    const { getPayrollList } = this.props;
    this.loadData(activePage, getPayrollList, PAYROLL_RUNS_LIST_PAGE_SIZE);
  };

  handleSelectDate = selectedDate => {
    this.setState({ selectedDate });
  };

  generatePayroll = () => {
    const { selectedDate } = this.state;
    const { generatePayroll } = this.props;
    generatePayroll(moment(selectedDate).format(monthDayYearFormat)).then(data => {
      if (data) {
        if (data.error && data.error.code === 'NON_APPROVED_JOBS_EXIST') {
          const jobIds = data.error.details.join(', ');
          return this.props.UIShowAlert(`Payroll generated but here are jobs 2 weeks prior but not yet approved: ${jobIds}`);
        }

        this.setState({
          selectedDate: null
        });
        this.loadPayrollList(0);
      }
    });
  };

  columnRenderer = data => {
    return [
      {
        Header: 'Date',
        accessor: 'payroll_date',
        Cell: props => {
          const { payroll_date } = props.original;
          return (
            <div>{moment.utc(payroll_date).format(uiDateFormatShort)}</div>
          );
        },
        width: 120
      },
      {
        Header: 'Payroll Download',
        accessor: 'url',
        Cell: props => {
          const { url } = props.original;
          return (
            <a className='download-link' href={url}>{url ? 'Download' : ''}</a>
          );
        },
        sortable: false,
        width: 130
      },
      {
        Header: 'Workers Comp Download',
        accessor: 'workers_comp_file',
        Cell: props => {
          const { workers_comp_file } = props.original;
          return (
            <a className='download-link' href={workers_comp_file}>{workers_comp_file ? 'Download' : ''}</a>
          );
        },
        sortable: false,
        width: 180
      },
      {
        Header: 'Number Of Rows',
        accessor: 'number_of_rows',
        width: getColumnWidth(data, 'number_of_rows', 'Number Of Rows')
      },
      {
        Header: 'Number Of Workers',
        accessor: 'number_of_workers',
        width: getColumnWidth(data, 'number_of_workers', 'Number Of Workers')
      }
    ];
  };

  render () {
    const { pagesQuantity } = this.props;
    const { loading, activePage, data, selectedDate } = this.state;
    return (
      <div>
        <div className='top-header'>
          <div className='page-title'>
            <div className='title-icon'>
              <FontAwesomeIcon icon={faFileAlt} size='lg' />
            </div>
            <h3>Payroll Runs</h3>
          </div>
        </div>
        <div className='payroll-date-wrapper'>
          <DatePicker
            placeholderText='Click to select a date'
            selected={selectedDate}
            onChange={this.handleSelectDate}
            dateFormat={uiDateFormatShort}
            className='input'
            dropdownMode='select'
          />
          <button
            className={`button button-primary run-payroll-btn ${!selectedDate ? 'disabled' : ''}`}
            onClick={this.generatePayroll}
          >
            Run Payroll
          </button>
        </div>
        <ReactTable
          data={data}
          loading={loading}
          pages={pagesQuantity}
          page={activePage}
          manual
          columns={this.columnRenderer(data)}
          showPageSizeOptions={false}
          onPageChange={this.loadPayrollList}
          onSortedChange={this.handleSorting}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    initialData: state.payroll.payrollRuns,
    pagesQuantity: state.payroll.pagesQuantity
  };
};

const mapDispatchToProps = {
  getPayrollList,
  generatePayroll,
  UIShowAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(Payroll);



// WEBPACK FOOTER //
// ./src/components/app/payroll/index.js